import { messageOf } from "../../services/auth";
import { authenticateWithPasskey } from "../../services/passkeys";

const UNUSABLE =
  "That passkey couldn't be used. Try again, or choose another way to sign in.";

export const passkeyProof = async (
  requestOptions,
  { autofill = false } = {},
) => {
  const options = await requestOptions();

  if (!options.ok) return { failure: messageOf(options) };

  const assertion = await authenticateWithPasskey({
    options: options.data.options,
    autofill,
  });

  return assertion.ok
    ? {
        proof: {
          method: "passkey",
          ceremonyId: options.data.ceremonyId,
          response: assertion.response,
        },
      }
    : assertion.cancelled
    ? { cancelled: true }
    : { failure: UNUSABLE };
};
